import { ICampaign } from '@store/campaigns'
import { IDraft } from '@store/drafts'

export const isSocialCampaign = (campaign?: ICampaign | IDraft) =>
  Boolean(
    campaign &&
      campaign.supported_submission_types &&
      campaign.supported_submission_types.includes('social_submission'),
  )
